module.exports = __webpack_public_path__ + "img/box-triangle-magenta.896092a1.svg";